import { render, staticRenderFns } from "./TotalVendaRenderer.vue?vue&type=template&id=ce1daab8&scoped=true&"
import script from "./TotalVendaRenderer.vue?vue&type=script&lang=ts&"
export * from "./TotalVendaRenderer.vue?vue&type=script&lang=ts&"
import style0 from "./TotalVendaRenderer.vue?vue&type=style&index=0&id=ce1daab8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1daab8",
  null
  
)

export default component.exports